import React from 'react';

/**
 * Page representing an agent's book of business.
 */
export const MyBook = () => {
  return (
    <div>
      <h2>My Book</h2>
    </div>
  );
};
